import type { HnsUri, HtsUri } from './uri.js';
import type { SecurityTier } from './security.js';
import type { MeshRoutingHeaders } from './routing.js';

export const CURRENT_PROTOCOL_VERSION = 1 as const;

declare const eventIdBrand: unique symbol;
export type EventId = string & {
  readonly [eventIdBrand]: true;
};

declare const pluginNamespaceBrand: unique symbol;
export type PluginNamespace = string & {
  readonly [pluginNamespaceBrand]: true;
};

export interface RawCollabEnvelope {
  protocolVersion: unknown;
  eventId: unknown;
  sourceUri: unknown;
  destinationUri: unknown;
  sessionId?: unknown;
  pluginId: unknown;
  senderId: unknown;
  createdAt: unknown;
  securityTier: unknown;
  routing?: unknown;
  payload: unknown;
  signature?: unknown;
}

export interface CollabEnvelope<T = unknown> {
  protocolVersion: typeof CURRENT_PROTOCOL_VERSION;
  eventId: EventId;
  sourceUri: HnsUri;
  destinationUri: HtsUri;
  sessionId?: string;
  pluginId: PluginNamespace;
  senderId: string;
  createdAt: number;
  securityTier: SecurityTier;
  routing?: MeshRoutingHeaders;
  payload: T;
  signature?: string;
}
